function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { StyledHeader } from '../elements/styledHeader';
const Header = ({
  children,
  hasDivider = false,
  ...other
}) => /*#__PURE__*/React.createElement(StyledHeader, _extends({
  hasDivider: hasDivider
}, other), children);
export { Header };